import { defineMessages } from 'react-intl';

export const engineeringMessages = defineMessages({
	incomingRequests: {
		id: 'JsmPortalPlayground.engineering.incomingRequests',
		defaultMessage: 'Incoming requests',
	},
	list: { id: 'JsmPortalPlayground.engineering.list', defaultMessage: 'List' },
	addView: { id: 'JsmPortalPlayground.engineering.addView', defaultMessage: 'Add view' },
	calendar: { id: 'JsmPortalPlayground.engineering.calendar', defaultMessage: 'Calendar' },
	board: { id: 'JsmPortalPlayground.engineering.board', defaultMessage: 'Board' },
	searchWork: { id: 'JsmPortalPlayground.engineering.searchWork', defaultMessage: 'Search work' },
	requestType: {
		id: 'JsmPortalPlayground.engineering.requestType',
		defaultMessage: 'Request type',
	},
	status: { id: 'JsmPortalPlayground.engineering.status', defaultMessage: 'Status' },
	assignee: { id: 'JsmPortalPlayground.engineering.assignee', defaultMessage: 'Assignee' },
	triage: { id: 'JsmPortalPlayground.engineering.triage', defaultMessage: 'Triage' },
	moreActions: {
		id: 'JsmPortalPlayground.engineering.moreActions',
		defaultMessage: 'More actions',
	},
	selectAll: {
		id: 'JsmPortalPlayground.engineering.selectAll',
		defaultMessage: 'Select all requests',
	},
	type: { id: 'JsmPortalPlayground.engineering.type', defaultMessage: 'Type' },
	summary: { id: 'JsmPortalPlayground.engineering.summary', defaultMessage: 'Summary' },
	timeToResolution: {
		id: 'JsmPortalPlayground.engineering.timeToResolution',
		defaultMessage: 'Time to resolution',
	},
	priority: { id: 'JsmPortalPlayground.engineering.priority', defaultMessage: 'P' },
	detailsPriority: {
		id: 'JsmPortalPlayground.engineering.detailsPriority',
		defaultMessage: 'Priority',
	},
	created: { id: 'JsmPortalPlayground.engineering.created', defaultMessage: 'Created' },
	selectRequest: {
		id: 'JsmPortalPlayground.engineering.selectRequest',
		defaultMessage: 'Select {summary}',
	},
	openRequest: {
		id: 'JsmPortalPlayground.engineering.openRequest',
		defaultMessage: 'Open {summary}',
	},
	unassigned: { id: 'JsmPortalPlayground.engineering.unassigned', defaultMessage: 'Unassigned' },
	closeDetails: {
		id: 'JsmPortalPlayground.engineering.closeDetails',
		defaultMessage: 'Close details',
	},
	description: { id: 'JsmPortalPlayground.engineering.description', defaultMessage: 'Description' },
	collapseDescription: {
		id: 'JsmPortalPlayground.engineering.collapseDescription',
		defaultMessage: 'Collapse description',
	},
	expandDescription: {
		id: 'JsmPortalPlayground.engineering.expandDescription',
		defaultMessage: 'Expand description',
	},
	reporterLine: {
		id: 'JsmPortalPlayground.engineering.reporterLine',
		defaultMessage: '<strong>{reporter}</strong> raised this request via <link>Portal</link>',
	},
	descriptionBody: {
		id: 'JsmPortalPlayground.engineering.descriptionBody',
		defaultMessage: '{summary}. {tail}',
	},
	affectedArea: {
		id: 'JsmPortalPlayground.engineering.affectedArea',
		defaultMessage: 'Affected area',
	},
	settings: { id: 'JsmPortalPlayground.engineering.settings', defaultMessage: 'Settings' },
	affectedService: {
		id: 'JsmPortalPlayground.engineering.affectedService',
		defaultMessage: 'Affected service',
	},
	checkoutApi: {
		id: 'JsmPortalPlayground.engineering.checkoutApi',
		defaultMessage: 'Checkout API',
	},
	slas: { id: 'JsmPortalPlayground.engineering.slas', defaultMessage: 'SLAs' },
	details: { id: 'JsmPortalPlayground.engineering.details', defaultMessage: 'Details' },
	firstResponse: {
		id: 'JsmPortalPlayground.engineering.firstResponse',
		defaultMessage: 'First response',
	},
	met: { id: 'JsmPortalPlayground.engineering.met', defaultMessage: 'Met' },
	resolution: { id: 'JsmPortalPlayground.engineering.resolution', defaultMessage: 'Resolution' },
	activity: { id: 'JsmPortalPlayground.engineering.activity', defaultMessage: 'Activity' },
	addInternalNote: {
		id: 'JsmPortalPlayground.engineering.addInternalNote',
		defaultMessage: 'Add internal note',
	},
	replyToCustomer: {
		id: 'JsmPortalPlayground.engineering.replyToCustomer',
		defaultMessage: 'Reply to customer',
	},
	assignedRequest: {
		id: 'JsmPortalPlayground.engineering.assignedRequest',
		defaultMessage: 'assigned the request to {assignee}',
	},
	addedToTriage: {
		id: 'JsmPortalPlayground.engineering.addedToTriage',
		defaultMessage: 'added the request to the triage queue',
	},
	raisedRequest: {
		id: 'JsmPortalPlayground.engineering.raisedRequest',
		defaultMessage: 'raised this request',
	},
	yesterdayAt: {
		id: 'JsmPortalPlayground.engineering.yesterdayAt',
		defaultMessage: 'Yesterday at {time}',
	},
	addedToBacklog: {
		id: 'JsmPortalPlayground.engineering.addedToBacklog',
		defaultMessage: 'Added to backlog',
	},
	moveSucceeded: {
		id: 'JsmPortalPlayground.engineering.moveSucceeded',
		defaultMessage: 'Work item successfully added to backlog',
	},
	moveSucceededDescription: {
		id: 'JsmPortalPlayground.engineering.moveSucceededDescription',
		defaultMessage:
			'This work item has been added to the <strong>Kanban backlog</strong> in Jira Software',
	},
	viewWorkItem: {
		id: 'JsmPortalPlayground.engineering.viewWorkItem',
		defaultMessage: 'View work item',
	},
	dismiss: { id: 'JsmPortalPlayground.engineering.dismiss', defaultMessage: 'Dismiss' },
	requestDetailsLabel: {
		id: 'JsmPortalPlayground.engineering.requestDetailsLabel',
		defaultMessage: '{key} details',
	},
	statusToDo: { id: 'JsmPortalPlayground.engineering.statusToDo', defaultMessage: 'To do' },
	statusTriaged: { id: 'JsmPortalPlayground.engineering.statusTriaged', defaultMessage: 'Triaged' },
	statusInProgress: {
		id: 'JsmPortalPlayground.engineering.statusInProgress',
		defaultMessage: 'In progress',
	},
	statusPendingOnReporter: {
		id: 'JsmPortalPlayground.engineering.statusPendingOnReporter',
		defaultMessage: 'Pending on reporter',
	},
	statusCompleted: {
		id: 'JsmPortalPlayground.engineering.statusCompleted',
		defaultMessage: 'Completed',
	},
	statusCancelled: {
		id: 'JsmPortalPlayground.engineering.statusCancelled',
		defaultMessage: 'Cancelled',
	},
	requestTypeBug: {
		id: 'JsmPortalPlayground.engineering.requestTypeBug',
		defaultMessage: 'Report a bug',
	},
	requestTypeFeature: {
		id: 'JsmPortalPlayground.engineering.requestTypeFeature',
		defaultMessage: 'Suggest a new feature',
	},
	requestTypeSupport: {
		id: 'JsmPortalPlayground.engineering.requestTypeSupport',
		defaultMessage: 'Technical support',
	},
	requestTypeSystem: {
		id: 'JsmPortalPlayground.engineering.requestTypeSystem',
		defaultMessage: 'Report a system problem',
	},
	priorityHighest: {
		id: 'JsmPortalPlayground.engineering.priorityHighest',
		defaultMessage: 'Highest',
	},
	priorityHigh: { id: 'JsmPortalPlayground.engineering.priorityHigh', defaultMessage: 'High' },
	priorityMedium: {
		id: 'JsmPortalPlayground.engineering.priorityMedium',
		defaultMessage: 'Medium',
	},
	priorityLow: { id: 'JsmPortalPlayground.engineering.priorityLow', defaultMessage: 'Low' },
	priorityLowest: {
		id: 'JsmPortalPlayground.engineering.priorityLowest',
		defaultMessage: 'Lowest',
	},
	priorityIconLabel: {
		id: 'JsmPortalPlayground.engineering.priorityIconLabel',
		defaultMessage: '{priority} priority',
		description: 'Accessible name for a priority icon. {priority} is a priority level, e.g. High.',
	},
	summarySaveButton: {
		id: 'JsmPortalPlayground.engineering.summarySaveButton',
		defaultMessage: 'Save button does nothing on the settings page',
	},
	summaryExportCsv: {
		id: 'JsmPortalPlayground.engineering.summaryExportCsv',
		defaultMessage: 'Allow exporting the queue to CSV',
	},
	summaryLoginTimeout: {
		id: 'JsmPortalPlayground.engineering.summaryLoginTimeout',
		defaultMessage: 'Login page is timing out for multiple users',
	},
	summaryDarkMode: {
		id: 'JsmPortalPlayground.engineering.summaryDarkMode',
		defaultMessage: 'Add a dark mode option to the reporting view',
	},
	summaryApiAuthError: {
		id: 'JsmPortalPlayground.engineering.summaryApiAuthError',
		defaultMessage: 'API returns an auth error after the latest release',
	},
	summaryConfigureSso: {
		id: 'JsmPortalPlayground.engineering.summaryConfigureSso',
		defaultMessage: 'Need help configuring SSO for the new workspace',
	},
	summaryCrmSync: {
		id: 'JsmPortalPlayground.engineering.summaryCrmSync',
		defaultMessage: 'Integration with the CRM stopped syncing overnight',
	},
	descriptionTailMoreDetails: {
		id: 'JsmPortalPlayground.engineering.descriptionTailMoreDetails',
		defaultMessage: 'Happy to provide more details if required.',
	},
	descriptionTailEndOfWeek: {
		id: 'JsmPortalPlayground.engineering.descriptionTailEndOfWeek',
		defaultMessage: 'I need this sorted before the end of the week.',
	},
	descriptionTailBlocking: {
		id: 'JsmPortalPlayground.engineering.descriptionTailBlocking',
		defaultMessage: 'This is blocking me from getting my work done today.',
	},
	slaToday1130Am: {
		id: 'JsmPortalPlayground.engineering.slaToday1130Am',
		defaultMessage: 'Today, 11:30 am',
	},
	slaToday400Pm: {
		id: 'JsmPortalPlayground.engineering.slaToday400Pm',
		defaultMessage: 'Today, 4:00 pm',
	},
	slaToday1130Pm: {
		id: 'JsmPortalPlayground.engineering.slaToday1130Pm',
		defaultMessage: 'Today, 11:30 pm',
	},
	slaTomorrow1130Am: {
		id: 'JsmPortalPlayground.engineering.slaTomorrow1130Am',
		defaultMessage: 'Tomorrow, 11:30 am',
	},
	slaTomorrow500Pm: {
		id: 'JsmPortalPlayground.engineering.slaTomorrow500Pm',
		defaultMessage: 'Tomorrow, 5:00 pm',
	},
	sla25Jun1130Pm: {
		id: 'JsmPortalPlayground.engineering.sla25Jun1130Pm',
		defaultMessage: '25 Jun, 11:30 pm',
	},
});
